import { useOverflowContext as e } from "./overflow-context.js";
import { DATA_OVERFLOW_ITEM as t } from "./constants.js";
import * as n from "react";
//#region src/shared/overflow/use-overflow-item.ts
function r(r, i, a, o) {
	let s = n.useRef(null), c = e((e) => e.registerItem);
	return n.useLayoutEffect(() => {
		if (!s.current) return;
		let e = s.current;
		return e.setAttribute(t, ""), c({
			element: e,
			id: r,
			priority: i ?? 0,
			groupId: a,
			pinned: o
		});
	}, [
		r,
		i,
		a,
		o,
		c
	]), s;
}
//#endregion
export { r as useOverflowItem };
